import React from 'react';
import { Share2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';
import type { List } from '@/types';

interface InheritedByProps {
  listId: string;
  allLists: List[];
}

export default function InheritedBy({ listId, allLists }: InheritedByProps) {
  const inheritingLists = allLists.filter(
    (l) => l.inherited_list_ids?.includes(listId)
  );

  if (inheritingLists.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 md:mt-12 p-4 md:p-6 bg-slate-100 border border-slate-200 rounded-lg">
      <div className="flex items-center gap-3 mb-3">
        <Share2 className="w-5 h-5 text-slate-500" />
        <h3 className="font-semibold text-slate-800">Inherited By Other Lists</h3>
      </div>
      <p className="text-sm text-slate-600 mb-4">
        The following lists are inheriting items from this list. Changes made here will be reflected in them.
      </p>
      <div className="flex flex-wrap gap-2">
        {inheritingLists.map(list => (
          <Link
            key={list.id}
            to={createPageUrl(`EditList?id=${list.id}`)}
            className="px-3 py-1 bg-white border border-slate-300 rounded-full text-sm font-medium text-slate-700 hover:bg-slate-50 hover:border-slate-400 transition-colors"
          >
            {list.title}
          </Link>
        ))}
      </div>
    </div>
  );
}
